import type { FC } from 'react';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Divider,
  Toolbar,
  useMediaQuery,
} from '@mui/material';
import { NavbarMenu } from './navbar-menu';
import type { Theme } from '@mui/material';
import { ChevronDown } from 'src/icons/chevron-down';
import { AccountPopover } from './account-popover';
import { useSetViewContext } from 'src/hooks/use-set-view-context';
import { useUserStore } from 'src/store/user-store';
import { SiteSelector } from './site-selector';
import { useAvailableSites } from 'src/hooks/api/use-available-sites';
import { SiteType } from 'src/types/enum/site-type';

export const Navbar: FC = () => {
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [openMenu, setOpenMenu] = useState(false);

  useUserStore();
  useSetViewContext();

  const infoApp = {
    icon: '/static/hilight_logo.svg',
    name: 'The HiLight',
  };

  // const helpjuiceUrl = () => {
  //   switch (i18n.language) {
  //     case 'en':
  //       return 'https://signalosio.helpjuice.com/en_US/signal-on-site';
  //     case 'pl':
  //       return 'https://signalosio.helpjuice.com/pl_PL/signal-on-site-';
  //   }
  // };

  const { data } = useAvailableSites();

  const residentialSites = data?.resources?.filter(
    site => site.type === SiteType.RESIDENTIAL,
  );

  return (
    <AppBar
      elevation={0}
      sx={{ backgroundColor: 'primary.dark', zIndex: '999' }}>
      <Toolbar
        disableGutters
        sx={{
          alignItems: 'center',
          display: 'flex',
          minHeight: 64,
          px: 4,
          py: 1,
          overflowY: {
            xs: 'auto',
            sm: 'none',
          },
        }}>
        <Box
          component={RouterLink}
          to="/"
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            width: {
              md: '153px',
              sm: '120px',
              xs: '70px',
            },
            transition: '0.3s',
            position: 'relative',
            '&:hover .apps': {
              visibility: 'visible',
              opacity: 1,
            },
          }}>
          <Box
            className="logo"
            sx={{
              transition: '0.3s',
              height: '100%',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
            }}>
            <img
              src={infoApp.icon}
              alt="logo"
              style={{
                minWidth: '100%',
                minHeight: '100%',
              }}
            />
          </Box>
        </Box>
        <NavbarMenu
          onClose={() => setOpenMenu(false)}
          open={mdDown && openMenu}
        />
        <Button
          endIcon={
            <ChevronDown
              fontSize="small"
              sx={{
                transition: 'transform 250ms',
                transform: openMenu ? 'rotate(180deg)' : 'none',
              }}
            />
          }
          onClick={() => setOpenMenu(true)}
          sx={{
            color: 'primary.contrastText',
            fontWeight: 400,
            display: {
              md: 'none',
              xs: 'flex',
            },
            fontSize: {
              md: '14px',
              xs: '12px',
            },
            mx: 2,
          }}
          variant="text">
          Menu
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        {residentialSites && residentialSites?.length > 1 ? (
          <SiteSelector />
        ) : null}
        <AccountPopover />
      </Toolbar>
      <Divider />
    </AppBar>
  );
};
